import type { JsonObject, KnowledgeCardDetail } from "../../shared/api/types";

export const targetFolders = ["00 Входящие", "10 Карточка", "20 Источники", "30 Карты"] as const;

export const relationKeys = [
  "зависит_от",
  "применяется_к",
  "уточняет",
  "проверяется_примерами",
  "реализуется_семействами",
  "реализуется_исполнениями",
  "семейство_изделия",
  "источники",
] as const;

const systemKeys = new Set(["id", "schema_version", "тип_карточки", "уровень_изделия", "статус", "проверено", ...relationKeys]);

export function stripLeadingTitle(markdown: string): string {
  return markdown.replace(/^\s*#\s+[^\r\n]*(?:\r?\n|$)/, "").trim();
}

export function editorFolder(detail: KnowledgeCardDetail | null): typeof targetFolders[number] {
  const folder = detail?.source_path.split("/")[0];
  return targetFolders.find((item) => item === folder) ?? "10 Карточка";
}

export function editorFilename(detail: KnowledgeCardDetail | null): string {
  return detail?.source_path.split("/").at(-1) || "Новая карточка.md";
}

export function extraProperties(properties: JsonObject): JsonObject {
  return Object.fromEntries(Object.entries(properties).filter(([key]) => !systemKeys.has(key)));
}

export function relationText(properties: JsonObject, key: typeof relationKeys[number]): string {
  const value = properties[key];
  if (Array.isArray(value)) return value.map(String).join("\n");
  return typeof value === "string" ? value : "";
}

export function parseExtraProperties(value: string): JsonObject {
  const parsed: unknown = JSON.parse(value || "{}");
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    throw new Error("Дополнительные свойства должны быть JSON-объектом");
  }
  const result = parsed as JsonObject;
  for (const key of systemKeys) delete result[key];
  return result;
}
